import { render, staticRenderFns } from "./_Switch.vue?vue&type=template&id=4040434d&scoped=true"
import script from "./_Switch.vue?vue&type=script&lang=js"
export * from "./_Switch.vue?vue&type=script&lang=js"
import style0 from "./_Switch.vue?vue&type=style&index=0&id=4040434d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4040434d",
  null
  
)

export default component.exports